// Opens a print-optimized window with the report and triggers the browser's
// "Save as PDF" flow. Produces a clean, branded datasheet.
import { toast } from "sonner";

export function exportReportPDF({ title, subtitle, bodyHTML }) {
  const win = window.open("", "_blank", "width=900,height=1000");
  if (!win) {
    toast.error("Please allow pop-ups for this site to download the PDF, then try again.");
    return false;
  }
  const date = new Date().toLocaleString();
  win.document.write(`<!doctype html><html><head><meta charset="utf-8"/>
  <title>${title || "Thermal Spray Atlas Report"}</title>
  <style>
    @page { margin: 18mm 16mm; }
    * { box-sizing: border-box; }
    body { font-family: 'IBM Plex Sans', Arial, sans-serif; color: #111; margin: 0; }
    .header { border-bottom: 3px solid #FF3B30; padding-bottom: 12px; margin-bottom: 18px; display:flex; justify-content:space-between; align-items:flex-end; }
    .brand { font-weight: 800; font-size: 20px; letter-spacing: -0.02em; }
    .brand span { color: #FF3B30; }
    .sub { color: #555; font-size: 12px; margin-top: 4px; }
    .meta { text-align:right; font-size: 10px; color:#888; font-family:'IBM Plex Mono', monospace; }
    h1 { font-size: 18px; margin: 16px 0 6px; }
    h2 { font-size: 14px; color:#FF3B30; text-transform: uppercase; letter-spacing: 0.04em; margin: 16px 0 6px; border-bottom:1px solid #eee; padding-bottom:4px; }
    h3 { font-size: 13px; color:#007AFF; margin: 12px 0 4px; }
    p, li { font-size: 12px; line-height: 1.6; }
    table { width: 100%; border-collapse: collapse; margin: 8px 0; font-family:'IBM Plex Mono', monospace; font-size: 11px; }
    th { background: #f4f4f5; text-align: left; padding: 6px 8px; border: 1px solid #ddd; color:#111; }
    td { padding: 6px 8px; border: 1px solid #ddd; color:#333; }
    code { font-family:'IBM Plex Mono', monospace; background:#f4f4f5; padding:1px 4px; border-radius:2px; }
    .footer { margin-top: 24px; border-top:1px solid #eee; padding-top:8px; font-size:9px; color:#999; }
  </style></head><body>
    <div class="header">
      <div>
        <div class="brand">THERMAL SPRAY <span>ATLAS</span></div>
        <div class="sub">${subtitle || "AI Coating Advisor — Datasheet"}</div>
      </div>
      <div class="meta">Generated<br/>${date}</div>
    </div>
    ${title ? `<h1>${title}</h1>` : ""}
    <div class="body">${bodyHTML}</div>
    <div class="footer">Generated by Thermal Spray Atlas. Values are literature-grounded estimates — validate against qualified process specifications before production use.</div>
    <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 300); };</script>
  </body></html>`);
  win.document.close();
  return true;
}
